import { useEffect, useState } from 'react';
import {
  fetchBenefitCategories,
  type BenefitCategory,
} from '#/domains/preview/api/govBenefitApi';

export function useBenefitCategories() {
  const [categories, setCategories] = useState<BenefitCategory[]>([]);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const controller = new AbortController();
    fetchBenefitCategories(controller.signal)
      .then(setCategories)
      .catch(err => {
        if ((err as { name?: string }).name === 'AbortError') return;
        setError(
          err instanceof Error ? err.message : '카테고리를 불러오지 못했어요.'
        );
      });
    return () => controller.abort();
  }, []);

  return { categories, error };
}
